import React from 'react'
import classNames from 'classnames'
import { Checkbox } from '@winnin/winnin_ui.components.checkbox'
import { TooltipWrapper } from '@winnin/winnin_ui.components.tooltip-wrapper'

import { useSelectedItemsList } from 'contexts/SelectedItemsListProvider'
import { useTranslate } from 'lib/tolgee'
import { isBrandComponentHidden } from 'modules/winnin-lite/common/winnin-lite.utils'
import { UserStore } from 'stores'

interface IAddVideoToCheckbox {
  id: string
  provider: string
  title: string
  thumbnail: string
  creatorName: string
  isModal?: boolean
  pinId?: string
}

export default function AddVideoToCheckBox({
  id,
  provider,
  title,
  thumbnail,
  creatorName,
  isModal,
  pinId,
}: IAddVideoToCheckbox) {
  const { addItem, removeItem, selectedItemsBar }: any = useSelectedItemsList()
  const checkIsActive = selectedItemsBar?.some(check => check.id === id)
  const isUserViewer = UserStore.getRole === 'viewer'
  const isHidden = isBrandComponentHidden('videoSelect')
  const t = useTranslate()

  function handleSelectionDefaultPrevented(e) {
    e.preventDefault()
    e.stopPropagation()
    const isItemSelected = selectedItemsBar.find(item => item.id === id)
    if (isItemSelected) {
      removeItem(isItemSelected)
      return
    }

    addItem({ id, name: title, type: 'posts', provider, thumbnail, creatorName, pinId })
  }

  if (isUserViewer || isHidden) return null

  return (
    <div
      className={classNames('AddVideoToCheckBox', {
        'AddVideoToCheckBox-modal': isModal,
        'AddVideoToCheckBox-checked': checkIsActive,
      })}
    >
      <TooltipWrapper
        tooltipMessage={t({ key: 'AddVideoToCheckBox-tooltip', defaultValue: 'Select this video' })}
        tooltipStyle={isModal ? 'tooltippedE' : 'tooltippedS'}
      >
        <Checkbox handleClick={handleSelectionDefaultPrevented} isActive={checkIsActive} className="checkbox" />
      </TooltipWrapper>
    </div>
  )
}
